class YakuList {
    // 一般手牌役種
    // 斷么九
    checkTanyao(hand) {
        const yaochuuTiles = new Set(["1m", "9m", "1p", "9p", "1s", "9s", "1z", "2z", "3z", "4z", "5z", "6z", "7z"]);

        // 確保手牌中沒有包含任何么九或字牌
        return hand.every((item) => item.tiles.every((tile) => !yaochuuTiles.has(tile)));
    }

    // 場風役牌
    checkRoundEast(hand, roundWind) {
        if (roundWind !== "東") return false; // 只有場風是東才判斷
        return hand.some((item) => item.tiles.join("") === "1z1z1z" || item.tiles.join("") === "1z1z1z1z");
    }
    checkRoundSouth(hand, roundWind) {
        if (roundWind !== "南") return false;
        return hand.some((item) => item.tiles.join("") === "2z2z2z" || item.tiles.join("") === "2z2z2z2z");
    }
    checkRoundWest(hand, roundWind) {
        if (roundWind !== "西") return false;
        return hand.some((item) => item.tiles.join("") === "3z3z3z" || item.tiles.join("") === "3z3z3z3z");
    }

    // 自風役牌
    checkSeatEast(hand, seatWind) {
        if (seatWind !== "東") return false; // 只有場風是東才判斷
        return hand.some((item) => item.tiles.join("") === "1z1z1z" || item.tiles.join("") === "1z1z1z1z");
    }
    checkSeatSouth(hand, seatWind) {
        if (seatWind !== "南") return false;
        return hand.some((item) => item.tiles.join("") === "2z2z2z" || item.tiles.join("") === "2z2z2z2z");
    }
    checkSeatWest(hand, seatWind) {
        if (seatWind !== "西") return false;
        return hand.some((item) => item.tiles.join("") === "3z3z3z" || item.tiles.join("") === "3z3z3z3z");
    }
    checkSeatNorth(hand, seatWind) {
        if (seatWind !== "北") return false;
        return hand.some((item) => item.tiles.join("") === "4z4z4z" || item.tiles.join("") === "4z4z4z4z");
    }

    // 三元牌役牌
    checkHaku(hand) {
        return hand.some((item) => item.tiles.join("") === "5z5z5z" || item.tiles.join("") === "5z5z5z5z");
    }
    checkHatsu(hand) {
        return hand.some((item) => item.tiles.join("") === "6z6z6z" || item.tiles.join("") === "6z6z6z6z");
    }
    checkChun(hand) {
        return hand.some((item) => item.tiles.join("") === "7z7z7z" || item.tiles.join("") === "7z7z7z7z");
    }

    // 門清自摸和
    checkMenzenTsumo(isMenzen, isTsumo) {
        return isMenzen && isTsumo;
    }

    // 平和
    checkPinfu(hand, waitType, roundWind, seatWind) {
        const windMap = {
            東: "1z",
            南: "2z",
            西: "3z",
            北: "4z",
        };

        const honorTiles = ["5z", "6z", "7z"];

        const allMeldsValid = hand.every((item) => {
            return item.type === "手牌順子" || item.type === "手牌雀頭";
        });

        const validWaitType = waitType === "兩面";

        let validPair = false;

        hand.filter((item) => item.type === "手牌雀頭").forEach((item) => {
            // 雀頭不能是場風、自風或三元牌
            const yakuMeld = [windMap[roundWind], windMap[seatWind], ...honorTiles];

            const tile = item.tiles[0];

            validPair = yakuMeld.includes(tile) ? false : true;
        });

        return allMeldsValid && validWaitType && validPair;
    }

    // 一杯口
    checkIipeikou(hand, isMenzen) {
        // 非門清沒有一杯口
        if (!isMenzen) return false;

        // 過濾出所有順子
        const sequences = hand.filter((item) => item.type === "手牌順子").map((item) => item.tiles.slice().sort().join(",")); // 轉成排序後的字串

        // 記錄順子出現次數
        const sequenceCount = new Map();
        sequences.forEach((seq) => {
            sequenceCount.set(seq, (sequenceCount.get(seq) || 0) + 1);
        });

        // 檢查是否有重複順子
        for (const count of sequenceCount.values()) {
            if (count >= 2) {
                return true; // 成立一杯口
            }
        }
        return false; // 不成立
    }

    // 對對和
    checkToitoi(hand) {
        return hand.every((item) => item.type === "手牌刻子" || item.type === "碰" || item.type === "暗槓" || item.type === "明槓" || item.type === "手牌雀頭");
    }

    // 三暗刻
    checkSanankou(hand, waitType, isTsumo) {
        // 找出手牌內的「暗刻」和「暗槓」
        let ankouCount = hand.filter((item) => item.type === "手牌刻子" || item.type === "暗槓").length;

        if (waitType === "雙碰" && !isTsumo) {
            ankouCount = ankouCount - 1;
        }

        // 確保至少有三組
        return ankouCount === 3;
    }

    // 三槓子
    checkSankantsu(hand) {
        // 找出手牌內的「明槓」和「暗槓」
        const kantsuCount = hand.filter((item) => item.type === "明槓" || item.type === "暗槓").length;

        // 確保至少有三組槓
        return kantsuCount === 3;
    }

    // 三色同刻
    checkSanshokuDoko(hand) {
        // 用來存放不同花色的刻子，key 為數字組合，value 為對應的花色集合
        const tripletMap = new Map();

        hand.forEach((item) => {
            if (item.type === "手牌刻子" || item.type === "碰" || item.type === "暗槓" || item.type === "明槓") {
                // 取得數字部分，例如 "111m" 轉為 "111"
                const numPart = item.tiles[0][0]; // 取第一張牌的數字
                const suit = item.tiles[0][1]; // 萬(m) / 筒(p) / 索(s)

                // 僅處理數牌（萬 m、筒 p、索 s）
                if (!["m", "p", "s"].includes(suit)) return;

                if (!tripletMap.has(numPart)) {
                    tripletMap.set(numPart, new Set());
                }
                tripletMap.get(numPart).add(suit);
            }
        });

        // 檢查是否有至少一組數字在不同花色中出現 3 次
        return Array.from(tripletMap.values()).some((suits) => suits.size === 3);
    }

    // 混老頭
    checkHonrouto(hand) {
        const honorTiles = ["1z", "2z", "3z", "4z", "5z", "6z", "7z"];
        const terminalTiles = ["1m", "9m", "1p", "9p", "1s", "9s"];
        const honorAndTerminalTiles = [...honorTiles, ...terminalTiles];

        // 判斷是否是字牌
        const isHonorTile = (tile) => honorTiles.includes(tile);

        // 判斷是否是數字牌
        const isterminalTile = (tile) => terminalTiles.includes(tile);

        // 檢查每個面子是否符合條件（只能包含這些牌且同時包含字牌和數字牌）
        const allMeldsContainBothHonorAndTerminal = hand.every((item) => {
            const allTilesAllowed = item.tiles.every((tile) => honorAndTerminalTiles.includes(tile));
            return allTilesAllowed;
        });

        // 檢查手牌是否只包含刻子、雀頭、碰、明槓、暗槓
        const onlyAllowedTypes = hand.every((item) => ["手牌刻子", "手牌雀頭", "碰", "明槓", "暗槓"].includes(item.type));

        // 檢查是否至少有一個面子包含字牌
        const hasHonorTileInAtLeastOneMeld = hand.some((item) => item.tiles.some((tile) => isHonorTile(tile)));

        // 檢查是否至少有一個面子包含數字牌
        const hasTerminalTileInAtLeastOneMeld = hand.some((item) => item.tiles.some((tile) => isterminalTile(tile)));

        return allMeldsContainBothHonorAndTerminal && onlyAllowedTypes && hasHonorTileInAtLeastOneMeld && hasTerminalTileInAtLeastOneMeld;
    }

    // 小三元
    checkShouSangen(hand) {
        // 三元牌的對應字牌
        const dragonTiles = ["5z", "6z", "7z"];

        // 記錄三元牌的出現情況
        let dragonCount = { "5z": 0, "6z": 0, "7z": 0 };

        hand.forEach((item) => {
            if (item.type === "手牌刻子" || item.type === "碰" || item.type === "明槓" || item.type === "暗槓") {
                if (dragonTiles.includes(item.tiles[0])) {
                    dragonCount[item.tiles[0]]++;
                }
            } else if (item.type === "手牌雀頭" && dragonTiles.includes(item.tiles[0])) {
                dragonCount[item.tiles[0]] += 0.5; // 雀頭標記為 0.5
            }
        });

        // 需要兩組三元牌刻子 + 1 組雀頭
        const dragons = Object.values(dragonCount);
        return dragons.filter((count) => count >= 1).length === 2 && dragons.includes(0.5);
    }

    // 三色同順
    checkSanshokuDoujun(hand) {
        // 用來存放不同花色的順子，key 為數字組合，value 為對應的花色集合
        const sequenceMap = new Map();

        hand.forEach((item) => {
            if (item.type === "手牌順子" || item.type === "吃") {
                // 取得數字部分，例如 "123m" 轉為 "123"
                const numPart = item.tiles.map((tile) => tile[0]).join("");
                const suit = item.tiles[0][1]; // 萬(m) / 筒(p) / 索(s)

                // 僅處理數牌（萬 m、筒 p、索 s）
                if (!["m", "p", "s"].includes(suit)) return;

                if (!sequenceMap.has(numPart)) {
                    sequenceMap.set(numPart, new Set());
                }
                sequenceMap.get(numPart).add(suit);
            }
        });

        // 檢查是否有至少一組數字在不同花色中出現 3 次
        return Array.from(sequenceMap.values()).some((suits) => suits.size === 3);
    }

    // 一氣通貫
    checkIttsu(hand) {
        // 取出所有手牌順子
        const sequences = {
            m: [],
            p: [],
            s: [],
        };

        hand.forEach((meld) => {
            if (meld.type === "手牌順子" || meld.type === "吃") {
                const suit = meld.tiles[0][1]; // 萬 (m)、筒 (p)、索 (s)
                sequences[suit].push(meld.tiles);
            }
        });

        // 檢查某個花色是否能組成一氣通貫
        const checkColor = (melds) => {
            const needed = [
                ["1", "2", "3"],
                ["4", "5", "6"],
                ["7", "8", "9"],
            ];
            const usedMelds = new Set();

            for (const group of needed) {
                const matchIndex = melds.findIndex((meld) => group.every((num) => meld.includes(num + meld[0][1])) && !usedMelds.has(meld));

                if (matchIndex === -1) return false; // 沒找到這段順子
                usedMelds.add(melds[matchIndex]); // 標記為已使用
            }

            return true;
        };

        return checkColor(sequences.m) || checkColor(sequences.p) || checkColor(sequences.s);
    }

    // 混全帶么九
    checkChanta(hand) {
        // 么九牌的集合
        const yaojiuTiles = new Set(["1m", "9m", "1p", "9p", "1s", "9s", "1z", "2z", "3z", "4z", "5z", "6z", "7z"]);
        const honorTiles = ["1z", "2z", "3z", "4z", "5z", "6z", "7z"];

        const isHonorTile = (tile) => honorTiles.includes(tile);

        let hasSequence = false; // 是否至少有一個順子

        // 遍歷所有面子與對子，檢查是否包含么九牌
        for (const item of hand) {
            const containsYaojiu = item.tiles.some((tile) => yaojiuTiles.has(tile));

            if (!containsYaojiu) {
                return false; // 只要有任何一組沒有包含么九牌，則不符合
            }

            if (item.type === "手牌順子" || item.type === "吃") {
                hasSequence = true; // 至少找到一組順子
            }
        }

        // 至少要有一個面子包含字牌
        const hasHonorTileInAtLeastOneMeld = hand.some((item) => item.tiles.some((tile) => isHonorTile(tile)));

        return hasSequence && hasHonorTileInAtLeastOneMeld;
    }

    // 混一色
    checkHonitsu(hand) {
        const suitSet = new Set();
        let hasHonorTile = false; // 是否有至少一組面子包含字牌

        for (const item of hand) {
            let containsHonor = false; // 該組面子是否包含字牌
            for (const tile of item.tiles) {
                const suit = tile.at(-1); // 取得最後一個字母（種類）
                suitSet.add(suit);
                if (suit === "z") containsHonor = true;
            }
            if (containsHonor) hasHonorTile = true;
        }

        return suitSet.size === 2 && suitSet.has("z") && hasHonorTile;
    }

    // 純全帶么九
    checkJunchan(hand) {
        // 么九牌的集合
        const yaojiuTiles = new Set(["1m", "9m", "1p", "9p", "1s", "9s"]);

        let hasSequence = false; // 是否至少有一個順子

        // 遍歷所有面子與對子，檢查是否包含么九牌
        for (const item of hand) {
            const containsYaojiu = item.tiles.some((tile) => yaojiuTiles.has(tile));

            if (!containsYaojiu) {
                return false; // 只要有任何一組沒有包含么九牌，則不符合
            }

            if (item.type === "手牌順子" || item.type === "吃") {
                hasSequence = true; // 至少找到一組順子
            }
        }

        return hasSequence; // 需至少包含一個順子
    }

    // 兩杯口
    checkRyanpeikou(hand) {
        // 先確認所有面子都是順子，並且手牌內只有四組順子和一個雀頭
        const melds = hand.filter((item) => item.type === "手牌順子");
        const pair = hand.find((item) => item.type === "手牌雀頭");

        if (melds.length !== 4 || !pair) return false; // 必須有四組順子和一個雀頭

        // 將順子轉為字串方便比較，例如 ["1m", "2m", "3m"] -> "1m2m3m"
        const meldStrings = melds.map((m) => m.tiles.sort().join(""));

        // 統計每組順子出現次數
        const countMap = {};
        for (const meld of meldStrings) {
            countMap[meld] = (countMap[meld] || 0) + 1;
        }

        // 檢查是否剛好有兩組不同的順子各出現兩次
        const twoPairs = Object.values(countMap).filter((count) => count === 2).length === 2;

        return twoPairs;
    }

    // 清一色
    checkChinitsu(hand) {
        // 取得手牌中所有的種類（m, p, s, z）
        const suitSet = new Set();

        for (const item of hand) {
            for (const tile of item.tiles) {
                const suit = tile.at(-1); // 取得最後一個字母（種類）
                if (suit === "z") return false; // 不能包含字牌
                suitSet.add(suit);
            }
        }

        return suitSet.size === 1; // 只有一種花色，才符合清一色
    }

    // 役滿
    // 大三元
    checkDaisangen(hand) {
        // 定義三元牌的刻子/槓子組合
        const daisangenSets = ["5z5z5z", "6z6z6z", "7z7z7z", "5z5z5z5z", "6z6z6z6z", "7z7z7z7z"];

        // 計算符合條件的面子數量
        const count = hand.filter((item) => daisangenSets.includes(item.tiles.join(""))).length;

        return count === 3; // 必須剛好有 3 組符合
    }

    // 小四喜
    checkShousuushii(hand) {
        // 定義四喜刻子的列表
        const windSets = ["1z", "2z", "3z", "4z"];

        // 記錄風牌的刻子/槓子數量
        let windCount = 0;
        let headWind = null;

        hand.forEach((item) => {
            if (item.type === "手牌刻子" || item.type === "碰" || item.type === "明槓" || item.type === "暗槓") {
                const tile = item.tiles[0]; // 取出該組的第一張牌
                if (windSets.includes(tile)) {
                    windCount++;
                }
            }
            if (item.type === "手牌雀頭") {
                headWind = item.tiles[0];
            }
        });

        // 需要 3 組風牌的刻子或槓子，且雀頭為剩下的風牌之一
        return windCount === 3 && windSets.includes(headWind);
    }

    // 大四喜
    checkDaisushi(hand) {
        // 定義四喜刻子的列表
        const windSets = ["1z", "2z", "3z", "4z"];

        // 記錄風牌的刻子/槓子數量
        let windCount = 0;

        hand.forEach((item) => {
            if (item.type === "手牌刻子" || item.type === "碰" || item.type === "明槓" || item.type === "暗槓") {
                const tile = item.tiles[0]; // 取出該組的第一張牌
                if (windSets.includes(tile)) {
                    windCount++;
                }
            }
        });

        // 需要 4 組風牌的刻子或槓子
        return windCount === 4;
    }

    // 字一色
    checkTsuuiisou(hand) {
        // 定義字牌的列表
        const honorTiles = ["1z", "2z", "3z", "4z", "5z", "6z", "7z"];

        // 遍歷手牌檢查所有牌是否都是字牌
        return hand.every((item) => item.tiles.every((tile) => honorTiles.includes(tile)));
    }

    // 綠一色
    checkRyuuiisou(hand) {
        // 綠一色允許的牌
        const greenTiles = ["2s", "3s", "4s", "6s", "8s", "6z"];

        // 檢查手牌中的所有牌是否都屬於 greenTiles
        return hand.every((item) => item.tiles.every((tile) => greenTiles.includes(tile)));
    }

    // 清老頭
    checkChinroutou(hand) {
        // 清老頭允許的牌
        const chinroutouTiles = ["1m", "9m", "1p", "9p", "1s", "9s"];

        // 檢查手牌中的所有牌是否都屬於 chinroutouTiles
        return hand.every((item) => item.tiles.every((tile) => chinroutouTiles.includes(tile)));
    }

    // 四暗刻
    checkSuuankou(hand, isMenzen, isTsumo, waitType) {
        // 需要門清
        if (!isMenzen) return false;

        // 需要自摸
        if (!isTsumo) return false;

        // 需要雙碰聽牌
        if (waitType !== "雙碰") return false;

        // 找出手牌內的「暗刻」和「暗槓」
        const ankouCount = hand.filter((item) => item.type === "手牌刻子" || item.type === "暗槓").length;

        // 共四組暗刻或暗槓
        return ankouCount === 4;
    }

    // 四暗刻單騎
    checkSuuankouTanki(hand, isMenzen, waitType) {
        // 需要門清
        if (!isMenzen) return false;

        // 需要雙碰聽牌
        if (waitType !== "單騎") return false;

        // 找出手牌內的「暗刻」和「暗槓」
        const ankouCount = hand.filter((item) => item.type === "手牌刻子" || item.type === "暗槓").length;

        // 共四組暗刻或暗槓
        return ankouCount === 4;
    }

    // 九蓮寶燈
    checkChuurenPoutou(hand, isMenzen, winningMeldIndex, winningTileIndex) {
        // 需要門清
        if (!isMenzen) return false;

        // 需要相同花色
        const suitSet = new Set();

        for (const item of hand) {
            for (const tile of item.tiles) {
                const suit = tile.at(-1); // 取得最後一個字母（種類）
                if (suit === "z") return false; // 不能包含字牌
                suitSet.add(suit);
            }
        }

        if (suitSet.size !== 1) return;

        const allTiles = [];
        const allTilesExcludingWinningTile = [];

        hand.forEach((item, index) => {
            allTiles.push(...item.tiles);

            if (index === winningMeldIndex) {
                allTilesExcludingWinningTile.push(...item.tiles.filter((_, i) => i !== winningTileIndex));
            } else {
                allTilesExcludingWinningTile.push(...item.tiles);
            }
        });

        const validDigits = ["1", "2", "3", "4", "5", "6", "7", "8", "9"];

        // 手牌為九蓮寶燈的形狀
        const vaildHands = (() => {
            const digitCount = allTiles.reduce((count, tile) => {
                const digit = tile[0]; // 只取數字部分
                if (validDigits.includes(digit)) {
                    count[digit] = (count[digit] || 0) + 1;
                } else {
                    // 如果包含無效數字，返回 false
                    return null;
                }
                return count;
            }, {});

            // 檢查是否包含無效數字
            if (digitCount === null) return false;

            // 檢查 1 和 9 至少 3 張
            if ((digitCount["1"] || 0) < 3 || (digitCount["9"] || 0) < 3) {
                return false;
            }

            // 檢查 2 到 8 至少 1 張
            for (let i = 2; i <= 8; i++) {
                if ((digitCount[String(i)] || 0) < 1) {
                    return false;
                }
            }

            return true;
        })();

        // 判斷聽牌是否為九面聽牌
        const vaildHandsExcludingWinningTile = (() => {
            const digitCount = allTilesExcludingWinningTile.reduce((count, tile) => {
                const digit = tile[0]; // 只取數字部分
                if (validDigits.includes(digit)) {
                    count[digit] = (count[digit] || 0) + 1;
                } else {
                    // 如果包含無效數字，返回 false
                    return null;
                }
                return count;
            }, {});

            // 檢查是否包含無效數字
            if (digitCount === null) return false;

            // 檢查 1 和 9 至少 3 張
            if ((digitCount["1"] || 0) !== 3 || (digitCount["9"] || 0) !== 3) {
                return false;
            }

            // 檢查 2 到 8 至少 1 張
            for (let i = 2; i <= 8; i++) {
                if ((digitCount[String(i)] || 0) !== 1) {
                    return false;
                }
            }

            return true;
        })();

        return vaildHands && !vaildHandsExcludingWinningTile;
    }

    // 純正九蓮寶燈
    checkJunseiChuurenPoutou(hand, isMenzen, winningMeldIndex, winningTileIndex) {
        // 需要門清
        if (!isMenzen) return false;

        // 需要相同花色
        const suitSet = new Set();

        for (const item of hand) {
            for (const tile of item.tiles) {
                const suit = tile.at(-1); // 取得最後一個字母（種類）
                if (suit === "z") return false; // 不能包含字牌
                suitSet.add(suit);
            }
        }

        if (suitSet.size !== 1) return;

        const allTiles = [];
        const allTilesExcludingWinningTile = [];

        hand.forEach((item, index) => {
            allTiles.push(...item.tiles);

            if (index === winningMeldIndex) {
                allTilesExcludingWinningTile.push(...item.tiles.filter((_, i) => i !== winningTileIndex));
            } else {
                allTilesExcludingWinningTile.push(...item.tiles);
            }
        });

        const validDigits = ["1", "2", "3", "4", "5", "6", "7", "8", "9"];

        // 手牌為九蓮寶燈的形狀
        const vaildHands = (() => {
            const digitCount = allTiles.reduce((count, tile) => {
                const digit = tile[0]; // 只取數字部分
                if (validDigits.includes(digit)) {
                    count[digit] = (count[digit] || 0) + 1;
                } else {
                    // 如果包含無效數字，返回 false
                    return null;
                }
                return count;
            }, {});

            // 檢查是否包含無效數字
            if (digitCount === null) return false;

            // 檢查 1 和 9 至少 3 張
            if ((digitCount["1"] || 0) < 3 || (digitCount["9"] || 0) < 3) {
                return false;
            }

            // 檢查 2 到 8 至少 1 張
            for (let i = 2; i <= 8; i++) {
                if ((digitCount[String(i)] || 0) < 1) {
                    return false;
                }
            }

            return true;
        })();

        // 判斷聽牌是否為九面聽牌
        const vaildHandsExcludingWinningTile = (() => {
            const digitCount = allTilesExcludingWinningTile.reduce((count, tile) => {
                const digit = tile[0]; // 只取數字部分
                if (validDigits.includes(digit)) {
                    count[digit] = (count[digit] || 0) + 1;
                } else {
                    // 如果包含無效數字，返回 false
                    return null;
                }
                return count;
            }, {});

            // 檢查是否包含無效數字
            if (digitCount === null) return false;

            // 檢查 1 和 9 至少 3 張
            if ((digitCount["1"] || 0) !== 3 || (digitCount["9"] || 0) !== 3) {
                return false;
            }

            // 檢查 2 到 8 至少 1 張
            for (let i = 2; i <= 8; i++) {
                if ((digitCount[String(i)] || 0) !== 1) {
                    return false;
                }
            }

            return true;
        })();

        return vaildHands && vaildHandsExcludingWinningTile;
    }

    // 四槓子
    checkSuukantsu(hand) {
        // 找出手牌內的「明槓」和「暗槓」
        const kantsuCount = hand.filter((item) => item.type === "明槓" || item.type === "暗槓").length;

        // 確保至少有四組槓
        return kantsuCount === 4;
    }
}

export default YakuList;
